var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.66667H8V9.16667V4.16667V3.66667H7.5H4.16667H3.66667V4.16667V9.16667V9.66667H4.16667H7.5ZM3.66667 15.8333V16.3333H4.16667H7.5H8V15.8333V14.1667V13.6667H7.5H4.16667H3.66667V14.1667V15.8333ZM12 15.8333V16.3333H12.5H15.8333H16.3333V15.8333V10.8333V10.3333H15.8333H12.5H12V10.8333V15.8333ZM12.5 3.66667H12V4.16667V5.83333V6.33333H12.5H15.8333H16.3333V5.83333V4.16667V3.66667H15.8333H12.5ZM11.3333 17V9.66667H17V17H11.3333ZM3 10.3333V3H8.66667V10.3333H3ZM3 17V13H8.66667V17H3ZM11.3333 3H17V7H11.3333V3Z",
    fill: "#52525B",
    stroke: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.7fe6d4037ec876991ba8d73cd1d7cfd4.svg";
export { ForwardRef as ReactComponent };